import { IUser } from "interfaces/models/IUser";
import { IUserStatusViewModel } from "interfaces/models/IUserStatusViewModel";

function mapUserStatusToViewModel(user: IUser, index: number) : IUserStatusViewModel {
  let statusTextValue: string = "REQUESTS";

  if (!user.requests) {
    switch (user.status!) {
      case 0:
        statusTextValue = "ACTIVE";
        break;
      case 1:
        statusTextValue = "LOCKED";
        break;
      case 2:
        statusTextValue = "INACTIVE";
        break;
      default:
        break;
    }
  }

  const userStatusViewModel : IUserStatusViewModel = {
    user,
    id: user.userId,
    emailAddress: user.emailAddress,
    username: user.username,
    status: statusTextValue,
    applicationCount: user.applicationCount,
    groups: user.groups,
    isFederatedUser: user.isFederatedUser,
    isPortalAdmin: user.isPortalAdmin,
    userCount: index
  };

  return userStatusViewModel;
}

function mapUserStatusesToViewModels(users : IUser[] | null) : IUserStatusViewModel[] {
  const userStatusViewModels: IUserStatusViewModel[] = [];

  if (users) {
    users.forEach((user, index): void => {
      userStatusViewModels.push(mapUserStatusToViewModel(user, index));
    });
  }

  return userStatusViewModels;
}

export { mapUserStatusesToViewModels };
